<template src="./AddUpdateUser.html"></template>
<script>
import Vue from "vue";
import { notifyError, notifyWarn } from "@/utils/notification-helper";
import { Grid } from "@progress/kendo-vue-grid";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("userManagement");
import $ from "jquery";
import FormGenerator from "@/components/Fields/FormGenerator";
Vue.component("Grid", Grid);
import { BTabs } from "bootstrap-vue";
import DialogBox from "@/components/DialogBox";
Vue.component("b-tabs", BTabs);
export default {
  components: {
    FormGenerator,
    DialogBox,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 180,
      vehicleData: {},
      userInfo: {},
      editField: false,
      editId: null,
      items: [],
      open: false,
      dataItems: [],
      name: null,
      email: null,
      mobileNo: null,  
      validation: {
        isInValidUserRole: false,
      },   

      userRoles: [],
      selectedUserRoles: null,
      updateUser: false,

      columns: [
        { field: "imei", title: "IMEI Number" },
        { field: "startDate", title: "Start Date" },
        { field: "endDate", title: "End Date" },
      ],

      template:
        "<span class='k-progress'></span>" +
        "<div class='file-wrapper'>" +
        "<span class='file-icon img-file'></span>" +
        "<h4 class='file-heading file-name-heading'>Name: #=name#</h4>" +
        "<h4 class='file-heading file-size-heading'>Size: #=size# bytes</h4>" +
        "<strong class='k-upload-status'>" +
        "<button type='button' " +
        "class='k-upload-action'></button>" +
        "<button type='button' class='k-upload-action'></button>" +
        "</strong>" +
        "</div>",
    };
  },
  computed: {
    ...mapState({
      schema: () => [],
    }),
    ...mapGetters(["getUserRoles"]),
  },
  created() {
    this.getVehicle();
    this.getDataOnload();
  },
  methods: {
    goToListPage: function () {
      this.$router.push({ name: "user-management" });
    },
    async getVehicle() {
      this.vehiclelist = this.$store.getters["vehicle/vehicleData"];
    },
    changeType() {},
    changeDriverType() {
      this.driverVal = this.vehicleData.driverID;
    },
    async getDataOnload() {
      await this.$store.dispatch("vehicle/getColumn");
    },
    resetData: function () {
      this.vehicleData = {};
    },
    validateFields (data) {
      // Apart from dropdownlist rest are auto validated
      if (data.userRole.length === 0) {
        this.validation.isInValidUserRole = true;
        return false;
      }
      return true;
    },
    addUser: function () {      
      const data ={
        name : this.name,
        email: this.email,
        mobileNo: this.mobileNo,
        userRole: this.selectedUserRoles ? [this.selectedUserRoles] : [],//this.userRoles.filter((ur) => this.selectedUserRoles.includes(ur.roleId)),
      }
      if (!this.validateFields(data)) {
        return false;
      }
      if (
        data.name &&
        data.email &&
        data.mobileNo &&
        data.userRole.length
      ) {
        let payload = {
          ...this.userInfo,
          ...data,
        };
        if (!this.$route.params.update) {
          this.$store
            .dispatch("userManagement/addUser", payload)
            .then((data) => {
              if (data.status) {
                this.goToListPage();
                this.resetData();
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          payload.id = this.userInfo.id;
          this.$store
            .dispatch("userManagement/updateUser", payload)
            .then(() => {
              this.goToListPage();
            })
            .catch((err) => {
              notifyError(err.response.data.message);
            })
            .finally(() => this.resetData());
        }
      } else {
        notifyWarn('Validation error!');
      }
    },

    setup: function () {
      return {
        rules: {
          getName(input) {
            if (input.is("[name='Name']") && input.val() == "") {
              return false;
            }

            return true;
          },
          getEmail(input) {
            if (input.is("[name='Email']") && input.val() == "") {
              return false;
            }
            return true;
          },
          getMobileNo(input) {
            if (input.is("[name='Contact Number']") && input.val() == "") {
              return false;
            }
            return true;
          },
          getUserRole(input) {
            if (input.is("[name='User Roles']") && input.val() == "") {
              return false;
            }
            return true;
          },
        },
        messages: {
          getName: "Name is required",
          getEmail: "Email is required",
          getMobileNo: "Contact Number is required",
          getUserRoleNumber: "User Role is required",

        },
      };
    },
    expandPanel() {
      $("#panelbar").kendoPanelBar();
      var panelBar = $("#panelbar").data("kendoPanelBar");
      panelBar.expand($("#item1"));

      if (this.schema.length != 0) {
        $("#panelbar3").kendoPanelBar();
        var panelBar3 = $("#panelbar3").data("kendoPanelBar");
        panelBar3.expand($("#item3"));
      }
    },
  },
  mounted() {
    this.getVehicle();
    this.expandPanel();

  },
  async beforeMount() {
    this.userRoles = this.$store.getters["userManagement/getUserRoles"]; //this.getUserRoles();
    this.userInfo = {}; // resetting values

    if (this.$route.params.update) {
      this.updateUser = true;
      const dataItem = this.$route.params.dataItem;
      this.userInfo = dataItem;
      this.name = dataItem.name;
      this.email = dataItem.email;
      this.mobileNo = dataItem.mobileNo;
      this.selectedUserRoles = dataItem.userRole.length ? dataItem.userRole[0] : null;//.map((ur) => ur.roleId);
    }
  },
};
</script>
<style lang="scss" scoped>
.file-icon {
  display: inline-block;
  float: left;
  width: 48px;
  height: 48px;
  margin-left: 10px;
  margin-top: 13.5px;
}

.img-file {
  background-image: url(https://demos.telerik.com/kendo-ui/content/web/upload/jpg.png);
}

.file-heading {
  font-family: Arial;
  font-size: 1.1em;
  display: inline-block;
  float: left;
  width: 60%;
  margin: 0 0 0 20px;
  height: 25px;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.file-name-heading {
  font-weight: bold;
  margin-top: 20px;
}

.file-size-heading {
  font-weight: normal;
  font-style: italic;
}

li.k-file div.file-wrapper {
  position: relative;
  height: 75px;
}

@media only screen and (max-width: 768px) {
.k-form, .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
}
.page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
}
.mobile_side_lbl{width: 70% !important;}
.mobile_side_btn{display: flex;}
.driver_header_mobile{flex-direction: row !important; overflow-x: auto; padding: 10px 10px 10px 10px;}
}

</style>
